export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/infographics.238a45e.svg";